import { defineMessages } from 'react-intl';
const geoSphereMessages = defineMessages({
  site: {
    id: 'GeoSphere Site',
    defaultMessage: 'Site',
  },
  plonesite: {
    id: 'GeoSphere Austria',
    defaultMessage: 'GeoSphere Austria',
  },
  closeMobileMenu: {
    id: 'Close GeoSphere Mobile menu',
    defaultMessage: 'Close menu',
  },
  back: {
    id: 'GeoSphere Mobile Back',
    defaultMessage: 'Back',
  },
  quicklinkPortals: {
    id: 'GeoSphere Quicklink Portals',
    defaultMessage: 'Schnellzugriff Portale',
  },
});
export default geoSphereMessages;
